export const CREATE_DISCOUNT_REQUEST = 'CREATE_DISCOUNT_REQUEST';
export const CREATE_DISCOUNT_SUCCESS = 'CREATE_DISCOUNT_SUCCESS';
export const CREATE_DISCOUNT_FAIL = 'CREATE_DISCOUNT_FAIL';
export const CREATE_DISCOUNT_RESET = 'CREATE_DISCOUNT_RESET';

export const LIST_DISCOUNTS_REQUEST = 'LIST_DISCOUNTS_REQUEST';
export const LIST_DISCOUNTS_SUCCESS = 'LIST_DISCOUNTS_SUCCESS';
export const LIST_DISCOUNTS_FAIL = 'LIST_DISCOUNTS_FAIL';

// Details
export const DISCOUNT_DETAILS_REQUEST = 'DISCOUNT_DETAILS_REQUEST';
export const DISCOUNT_DETAILS_SUCCESS = 'DISCOUNT_DETAILS_SUCCESS';
export const DISCOUNT_DETAILS_FAIL = 'DISCOUNT_DETAILS_FAIL';

// Update
export const UPDATE_DISCOUNT_REQUEST = 'UPDATE_DISCOUNT_REQUEST';
export const UPDATE_DISCOUNT_SUCCESS = 'UPDATE_DISCOUNT_SUCCESS';
export const UPDATE_DISCOUNT_FAIL = 'UPDATE_DISCOUNT_FAIL';
export const UPDATE_DISCOUNT_RESET = 'UPDATE_DISCOUNT_RESET';

// Delete
export const DELETE_DISCOUNT_REQUEST = 'DELETE_DISCOUNT_REQUEST';
export const DELETE_DISCOUNT_SUCCESS = 'DELETE_DISCOUNT_SUCCESS';
export const DELETE_DISCOUNT_FAIL = 'DELETE_DISCOUNT_FAIL';
export const DELETE_DISCOUNT_RESET = 'DELETE_DISCOUNT_RESET';